module.exports = __webpack_public_path__ + "img/Q.01842372.png";